module.exports = __webpack_public_path__ + "img/collection-engagementRingsVintage.c58b0be.jpg";